module.exports = __webpack_public_path__ + "img/soccer4.59a7d69f.svg";